export default __webpack_public_path__ + "static/media/3.48fcf4c1.PNG";